import * as Sentry from '@sentry/browser'
import { kAgentV2RouterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { getResponseDebugContext, getTopLevelKeys } from '@/util/api/response-body'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'
import { AgentV2ConversationSummary, AgentV2ConversationSummarySchema } from '@/agent-v2/store/schemas'
import { agentV2Request } from './agent-v2-request'

export async function patchGenerateAgentV2ConversationTitle(conversationId: string): Promise<AgentV2ConversationSummary> {
  const url = `${kPaxtonAppApiRESTBaseUrl()}${kAgentV2RouterApiBasePath}/conversations/${conversationId}/title/generate`
  return agentV2Request({
    url,
    method: 'PATCH',
    sentryEndpoint: 'PATCH /api/v2/agent/conversations/{conversation_id}/title/generate',
    parseResponse: (data, { response, sentryTags }) => {
      const parsed = AgentV2ConversationSummarySchema.safeParse(data)
      if (parsed.success) return parsed.data

      Sentry.withScope((scope) => {
        scope.setTags(sentryTags)
        Sentry.captureException(new Error('Agent v2 generated title response schema validation failed'), {
          extra: {
            ...getResponseDebugContext(response, url),
            conversationId,
            responseKeys: getTopLevelKeys(data),
            issues: parsed.error.issues,
          },
        })
      })
      throw new ApiResponsePayloadError(response.status, 'Invalid Agent v2 generated title response shape', parsed.error.issues)
    },
  })
}
